import featuredImage from "assets/images/resource/staff-solutions-5.jpg";

const weDOSectionITSol = {
  title: "I. Consultations",
  title2: "II. Website design",
  title3: "III. Support",
  featuredImage,
  text: "",
  barTitle: "Consultation-Design-Support",
  barPercent: 100,
  Consultation: [
    {
      id: 1,
      title: "Website Design",
      text: "Consultation-Design-Support",
    },
        {
      id: 2,
      title: "IT Enquiries",
      text: "Consultation-Design-Support",
    }
  ],
  Website: [
    {
      id: 1,
      title: "Temporary Landing Page",
      text: "Consultation-Design-Support",
    },
    {
      id: 2,
      title: "Test Website",
      text: "Consultation-Design-Support",
    },
    ,
    {
      id: 3,
      title: "Final Website",
      text: "Consultation-Design-Support",
    }
  ],
  Support: [
    {
      id: 1,
      title: "Website Content Update",
      text: "Consultation-Design-Support",
    },
    {
      id: 2,
      title: "Account Hosting",
      text: "Consultation-Design-Support",
    },
    {
      id: 3,
      title: "Corporate Emails",
      text: "Consultation-Design-Support",
    }
  ],
};

export default weDOSectionITSol;
